import type { ComponentProps, ElementType } from "react";
import { tv, type VariantProps } from "tailwind-variants";

export type HeadingProps = Required<VariantProps<typeof headingVariants>> & ComponentProps<"h1">;

const headingVariants = tv({
  base: "",
  variants: {
    level: {
      1: "text-3xl font-bold text-balance text-content sm:text-4xl",
      2: "text-2xl font-bold text-balance text-content sm:text-3xl",
      3: "text-xl font-semibold sm:text-2xl",
      4: "text-lg font-semibold sm:text-xl",
      5: "text-base font-medium sm:text-lg",
      6: "text-sm font-medium sm:text-base",
    },
  },
});

export const Heading = ({ children, className, level, ...props }: HeadingProps) => {
  const Tag: ElementType = `h${level}`;

  return (
    <Tag className={headingVariants({ className, level })} {...props}>
      {children}
    </Tag>
  );
};
